import React, { Component } from 'react';
import invoke from 'react-native-webview-invoke/browser'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../Custom-css.css';

import {Container, Button} from 'react-bootstrap'
import history from './../../history';
import { IoArrowBack, IoLogoWhatsapp, IoPrint } from "react-icons/io5";
import Swal from 'sweetalert2'

const {
    REACT_APP_API_URL,
} = process.env;

const swalBirubi = Swal.mixin({
    customClass: {
        header: 'p-0 m-0',
        confirmButton: 'btn btn-birubi-outline btn-sm color-birubi',
        cancelButton: 'btn btn-outline-dark btn-sm ml-2'
    },
    buttonsStyling: false
})

const PRINT_WEB_LOG_TAG = '[BirubiPrintWeb]';

const printWebLog = (step, data) => {
    if(data === undefined){
        console.log(PRINT_WEB_LOG_TAG, step)
        return
    }

    console.log(PRINT_WEB_LOG_TAG, step, data)
}

const printWebError = (step, error, context = {}) => {
    console.log(PRINT_WEB_LOG_TAG, step, {
        ...context,
        error: error instanceof Error ? {message: error.message, stack: error.stack} : {message: String(error)}
    })
}

class CetakNotaVoucher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            print_color: 'text-danger'
        };
        this.query = new URLSearchParams(this.props.location.search);
        this.goToPrint = invoke.bind('goToPrint');
        this.konekBluetooth = invoke.bind('konekBluetooth');
        this.handlePrintConnection = this.handlePrintConnection.bind(this);
        this.handlePrintStatus = this.handlePrintStatus.bind(this);
        this.printNota = this.printNota.bind(this);
        this.notaWA = this.notaWA.bind(this);
        this.konekB = this.konekB.bind(this);
    }

    componentDidMount(){
        invoke.define('changePrint', this.handlePrintConnection)
        invoke.define('statusPrint', this.handlePrintStatus)
        printWebLog('voucher:bridge:callbacks-defined')

        if(localStorage.getItem('token') === null){
            history.replace('/')
            return
        }

        this.konekB()
    }

    handlePrintConnection(hasil) {
        printWebLog('voucher:callback:changePrint', {hasil})
        this.setState({
            print_color: hasil === 1 ? 'text-success' : 'text-danger'
        })
    }

    handlePrintStatus(status) {
        printWebLog('voucher:callback:statusPrint', {status})
        swalBirubi.close()
        if(status === 'berhasil' || status === 'sukses'){
            swalBirubi.fire(
                'Nota berhasil diproses!',
                'Silahkan lanjutkan proses nota.'
            )
        }else if(status === 'printer_tidak_terhubung'){
            swalBirubi.fire(
                'Printer belum terhubung!',
                'Silahkan pilih printer terlebih dahulu, lalu coba cetak lagi.'
            )
        }else{
            swalBirubi.fire(
                'Cetak nota gagal!',
                'Silahkan coba print lagi.'
            )
        }
    }

    getPrintRequest(endpoint){
        const params = new URLSearchParams({
            kode_user: localStorage.getItem('kode_user'),
            schema: localStorage.getItem('schema'),
            kdTx: this.query.get('kdTx'),
            api_token: localStorage.getItem('token')
        })

        const request = {
            urlGetNota: REACT_APP_API_URL+endpoint+'?'+params.toString(),
            api_token: localStorage.getItem('token')
        }

        printWebLog('voucher:request:build', {endpoint, request})
        return request
    }

    async printNota(){
        swalBirubi.fire(
            'Cetak Nota Voucher!',
            'Silahkan periksa printer anda. Pastikan HP terkoneksi dengan internet!'
        )

        const request = this.getPrintRequest('get-nota-voucher-cust')
        printWebLog('voucher:command:goToPrint:send', {endpoint: 'get-nota-voucher-cust', request})
        try{
            await this.goToPrint(request)
            printWebLog('voucher:command:goToPrint:accepted')
        }catch(error){
            printWebError('voucher:command:goToPrint:error', error, {request})
            this.handlePrintStatus('gagal')
        }
    }

    async notaWA(){
        const request = this.getPrintRequest('get-nota-voucher-wa')
        printWebLog('voucher:command:goToPrint:send', {endpoint: 'get-nota-voucher-wa', request})
        try{
            await this.goToPrint(request)
            printWebLog('voucher:command:goToPrint:accepted')
        }catch(error){
            printWebError('voucher:command:goToPrint:error', error, {request})
            this.handlePrintStatus('gagal')
        }
    }

    async konekB(){
        try{
            await this.konekBluetooth()
        }catch(error){
            printWebError('voucher:bridge:konekBluetooth:error', error)
        }
    }

    render() {
        const nomorNota = this.query.get('nota') || this.query.get('kdTx') || '-'

        return (
            <div>
                <div className="fixed-position bg-white">
                    <div className="header border-bottom shadow-sm" style={{paddingRight: 20}}>
                        <div className="d-flex align-items-center">
                            <div onClick={() => history.goBack()} style={{width: 36, flex: '0 0 36px'}}>
                                <h5 className="m-0"><IoArrowBack /></h5>
                            </div>
                            <div className="flex-grow-1">
                                <h4 className="m-0">Nota Voucher</h4>
                            </div>
                            <div onClick={() => this.konekB()} style={{width: 40, flex: '0 0 40px', textAlign: 'center'}}>
                                <h4 className="m-0 p-0"><IoPrint className={this.state.print_color} /></h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-reg pb-detailTx">
                    <Container>
                        <div className="border p-3 mb-3 bg-white">
                            <div className="text-grey">No. Nota Voucher</div>
                            <h4 className="font-weight-bold">{nomorNota}</h4>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <Button className="btn-light w-100 btn-birubi-outline text-white" disabled={this.state.disabled} block onClick={ () => this.notaWA() }>
                                    <span className="color-birubi"><h4 className="m-0 p-0"><IoLogoWhatsapp /></h4> Whatsapp </span>
                                </Button>
                            </div>
                            <div className="col-6">
                                <Button className="btn-light w-100 btn-birubi-outline text-white" disabled={this.state.disabled} block onClick={ () => this.printNota() }>
                                    <span className="color-birubi"><h4 className="m-0 p-0"><IoPrint /></h4> Cetak </span>
                                </Button>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        );
    }
}

export default CetakNotaVoucher;
